import React from 'react'
import Routes from './Routes'
import ReactDOM from 'react-dom/client'

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
)